import l10n from '../l10n/localization';

export default {
    name: {
        presence: {
            message: l10n.validation.required,
        },
    },
};



// WEBPACK FOOTER //
// ./src/validation/clientRate.js